import { Component, OnInit, OnDestroy, ElementRef }     from '@angular/core';
import { ActivatedRoute, Router }           from '@angular/router';
import { Response }                         from '@angular/http';
import { DealersService }                   from '../../_services/dealers.service';
import { CarsService } 			            from '../../_services/cars.service';
import { Dealer }                           from '../../_models/dealer';
import { ToasterModule,
         ToasterService,
         ToasterConfig }                    from 'angular2-toaster/angular2-toaster';
import { Car }                              from '../../_models';
import { CustomersService }                 from '../../_services/customers.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Customer } from '../../_models/customer';

@Component({
  selector: 'app-dealerpage',
  templateUrl: 'dealerpage.component.html',
  styleUrls: ['dealerpage.component.css'],
  providers: [DealersService, CarsService, CustomersService]
})
export class DealerPageComponent implements OnInit, OnDestroy {
    public user: any;
    public dealer: Dealer= new Dealer();
    public sub: any;
    private isLoading: boolean = false;
    public showMain:boolean = false;
    private isDealerCodeVerified: boolean = false;
    public errorMessage:string = '';    
    public dealerId: string='';
    public toOldCar: boolean = false;
    public carMake: string;
    public backgroundColor: string;
    public registration: string = '';
    public dealerCode: string = '';
    public invalidDealerCodeMessage: string = '';
    public sellerInitialsErrorMessage: string = '';
    public sellerInitials: string = '';
    public dealerSA: string = ''; //"Serviceaftale" nameing frontend
    private cars: Car[] = [];
    private data: Car[] = [];

    public options:any = {
		brands: [],
        models: [],
        versions: []
    };
    
    public brandSelected: any;
    public modelSelected: any;
    public versionSelected: any;
    public monthOldSelected: any = 0;
    private carselected: boolean;
    private hasMakeQueryParam: boolean;
    public customerRegNr: string;
    public regNrSearchError: string;
    public regNrSearchMessage: string;

    private toasterService: ToasterService;

    private showSearchByReg: boolean = true;
    private showSellerInitials: boolean = true;

    private showNellemannColors: boolean = false;

    constructor(
                private dealersService: DealersService,
                private carsService: CarsService,
                private customersService: CustomersService,
                private route: ActivatedRoute,
                private router: Router,
                private modalService: NgbModal,
                private elementRef : ElementRef,
                toasterService: ToasterService){
      this.toasterService = toasterService;
    }

    ngOnInit(){

        this.carselected = false;
        this.dealerSA = 'serviceabonnement';

        // clear session storage variables
        sessionStorage.removeItem('sellerInitial');
        sessionStorage.removeItem("customer_reg_search");

        this.route.queryParams.subscribe(params => {
            this.carMake = params['make'];
            this.backgroundColor = params['background'];

            if (params['sellerInitials'] && params['sellerInitials'] == 'false') {
                this.showSellerInitials = false;
            }

            if (params['regsearch'] && params['regsearch'] == 'false') {
                this.showSearchByReg = false;
            }

            if (this.carMake) {
                this.hasMakeQueryParam = true;
            }
            else {
                this.hasMakeQueryParam = false;
            }
            //If background parameter is set, change background color
            if (this.backgroundColor) {
                /*this.elementRef.nativeElement.ownerDocument
                    .body.style.backgroundColor = this.backgroundColor;*/
                document.body.style.backgroundColor = this.backgroundColor;
            }
        })

        this.sub = this.route.params.subscribe(params => {
          this.dealerId = params['id'];
          this.dealersService
            .get(this.dealerId)
            .subscribe(
              p =>  {
                      this.dealer = p;

                        //Check if dealer is nellemann
                        if (this.dealer._id == '5ec7b995f99d985b5e8f02ab') {
                            this.showNellemannColors = true;
                        }
                        //Check if dealer is stsbiler
                        if (this.dealer._id == '63591e878c577855251e44b4') {
                            this.dealerSA= 'serviceaftale';
                        }

                      this.user=p.employees[0];                      
                    }
            );
            this.getCars();
        });
        setInterval(function() {
    window.top.postMessage(document.body.scrollHeight, "*");
}, 500);
        
    }

    ngOnDestroy(){
        this.sub.unsubscribe();
    }

    getCars(){        
        this.carsService
          .getDealer(this.dealerId)
          .subscribe(
                p => {
                    p.forEach(car => {
                        if (car.carmake != "HIDDEN") {
                            this.cars.push(car);
                        }
                    }
                )
                },
                e => this.errorMessage = e,
                () => {

                        if (this.carMake) {
                            this.brandSelected = this.carMake;
                        }

                        this.data=this.cars;
                        this.isLoading = false;
                        
                        for (var i = 0; i < this.data.length; ++i) {
                            if (!(this.options.brands.indexOf(this.data[i].carmake) > -1)) {
                                this.options.brands.push(this.data[i].carmake);
                            }                                                        
                        }
                        this.updateModels();
                    });
    }

    carSelected():void {
        // Sondrup service aftaler doesn't need to pick monthsOldSelected
        if (this.dealerId == "63510bb88c577855251e357e") {
            this.monthOldSelected = -1;
            this.gotoCar();
        }
        else {
            this.carselected = true;
        }
    }

    gotoCar():void {

        if(this.dealerCode && this.isDealerCodeVerified && this.isNullOrUndefinedOrEmpty(this.sellerInitials))
        {
            this.sellerInitialsErrorMessage = "Initialer is required.";
        }
        else if(!this.isNullOrUndefinedOrEmpty(this.sellerInitials) && this.sellerInitials.length > 15)
        {
            this.sellerInitialsErrorMessage = "Please enter at max 15 character.";
        }
        else
        {
            sessionStorage.setItem('sellerInitial', this.sellerInitials);
            this.sellerInitialsErrorMessage = "";
            var carDetail = this.data.filter(e=>e.carmake == this.brandSelected && e.carmodel == this.modelSelected && e.carversion == this.versionSelected)[0];
            if(carDetail != undefined && carDetail != null)
            {            
                this.router.navigate(['/dealercalculator'],{ queryParams: { id: carDetail._id, monthOldSelected: this.monthOldSelected } });
            }
        }
    }

    getCustomer()
    {        
        if(this.dealerCode && this.isDealerCodeVerified && this.isNullOrUndefinedOrEmpty(this.sellerInitials))
        {
            this.sellerInitialsErrorMessage = "Initialer is required.";
        }
        else if(!this.isNullOrUndefinedOrEmpty(this.sellerInitials) && this.sellerInitials.length > 15)
        {
            this.sellerInitialsErrorMessage = "Please enter at max 15 character.";
        }
        else
        {
            sessionStorage.setItem('sellerInitial', this.sellerInitials);
            this.sellerInitialsErrorMessage = "";
            let customers : Customer[];
            let regno = this.registration.replace(/ /g,'');
            this.customersService
            .getCustomerByRegistration(regno)
                .subscribe(
                        p => customers = p,
                        e => this.errorMessage = e,
                        () => {
                                this.isLoading = false;
                                this.toOldCar = false;
                                if(customers != undefined && 
                                    customers != null && 
                                    customers.length > 0 && 
                                    customers[0].dealer !=null && 
                                    customers[0].dealer != undefined && 
                                    customers[0].dealer[0]._id == this.dealerId)
                                {
                                    let d = new Date(Date.now());
                                    let d2 = new Date(customers[0].firstreg);
                                    if(d.getFullYear()-d2.getFullYear() > 1) {
                                        this.toOldCar = true;
                                        document.getElementById('buttonModal').click(); 
                                    }
                                    if((d.getFullYear()-d2.getFullYear()) >= 1 && (d.getMonth()-d2.getMonth() >= 1)) {
                                        this.toOldCar = true;
                                        document.getElementById('buttonModal').click(); 
                                    } 
                                    if(!this.toOldCar) {
                                        this.router.navigate(['/calculator'],{ queryParams: { cust: customers[0]._id, dealercalc: true,  regsearch: this.showSearchByReg == true ? "true" : "false" } });
                                    }                                                               
                                }
                                else
                                {
                                    document.getElementById('buttonModal').click();                                
                                }
                        });    
        }    
    }

    openMessageModal(dialogId)
    {
        this.modalService.open(dialogId).result.then((result) => {
            if(result){
              if(result=="close"){                
              }
            }
          })
    }

    updateModels()
    {
        this.options.models = [];
        this.modelSelected = null;
        this.versionSelected = null;

        for (var i = 0; i < this.data.length; ++i) {
            if (!(this.options.models.indexOf(this.data[i].carmodel) > -1) && this.data[i].carmake == this.brandSelected) {                
                this.options.models.push(this.data[i].carmodel);
            }           
        }

        this.modelSelected = this.options.models[0];
        this.updateVersions();
    }

    updateVersions()
    {
        this.options.versions = [];
        this.versionSelected = null;

        for (var i = 0; i < this.data.length; ++i) {
            if (!(this.options.versions.indexOf(this.data[i].carversion) > -1) && this.data[i].carmodel == this.modelSelected) {                
                this.options.versions.push(this.data[i].carversion);
            }          
        }
        this.versionSelected = this.options.versions[0];
    }

    validateDealerCode()
    {
        if(this.dealerCode != undefined && this.dealerCode == this.dealer.dealerCode)
        {      
            this.invalidDealerCodeMessage = '';
            this.isDealerCodeVerified = true;    
        }
        else{
            this.invalidDealerCodeMessage = "Entered Dealer code is invalid";
            this.isDealerCodeVerified = false;    
        }
    }

    findCustomerByRegNr() 
    {
        this.customersService.findByRegNumber(this.customerRegNr, this.dealerId).subscribe(
			(response) => {
				this.regNrSearchError = '';
				this.regNrSearchMessage = 'Kunde blev fundet!';

				const customer = response.json();
				customer.regnr = this.customerRegNr;
                sessionStorage.setItem("customer_reg_search", JSON.stringify(customer));
			},
			(error) => {
                sessionStorage.removeItem("customer_reg_search");
				this.regNrSearchMessage = '';
				this.regNrSearchError = 'Kunde blev ikke fundet!';
			}
		);
    }

    formatRegistration(value)
    {
        if (value) {
            value = value.toUpperCase(); 
            value = value.replace(/ /g,''); 
            if (value.match(/^[A-Z]{2}\d*$/)) {                
                if(value.length > 4)
                {
                    value = value.substr(0, 2) + ' ' + value.substr(2,2) +  ' ' + value.substr(4);
                }
                else
                {
                    value = value.substr(0, 2) + ' ' + value.substr(2);
                }
            }
        }

        this.registration = value;
    }

    isNullOrUndefinedOrEmpty(object) {
        if (object == null || object == undefined || object == '') {
            return true;
        }
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/landingpages/dealerpage/dealerpage.component.ts